import { useContext } from "react";

import { AnyEntity } from "@mapmycustomers/shared/types/entity";

import ICalendarViewContext from "@app/component/view/CalendarView/types/ICalendarViewContext";

import ViewContext from "../../utils/ViewContext";

const useCalendarView = <T extends AnyEntity>(): ICalendarViewContext<T> => {
  // we use the same ViewContext everywhere to guarantee that even if you used
  // <CalendarView> somewhere, you can still use useView hook to get access to a
  // portion of its context.
  return useContext(ViewContext) as unknown as ICalendarViewContext<T>;
};

export default useCalendarView;
